<template>
  <sea-page
    class="mt-3"
    title="Cambio password"
    header="Cambio password"
    :showCompanyHeader="activeProfile.role !== 'ROLE_CONSULTANT'"
    back
  >
    <sea-page-content toolbar hideRapidSearch>
      <template v-slot:toolbar>
        <table-toolbar-button
          icon="mdi-content-save"
          label="Salva"
          @click="changePassword"
          :disabled="$v.resetPassword.$invalid"
        ></table-toolbar-button>
      </template>
      <v-card max-width="600" flat>
        <v-card-title>
          <p class="text-caption" style="word-break: keep-all">
            *{{ pwdPolicyRules }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="10" offset="1">
                <v-text-field
                  v-model="$v.resetPassword.currentPassword.$model"
                  label="Password corrente"
                  :type="pwdVisible ? 'text' : 'password'"
                  :error-messages="currentErrors"
                  @input="$v.resetPassword.currentPassword.$touch()"
                  @blur="$v.resetPassword.currentPassword.$touch()"
                  required
                >
                  <template v-slot:append>
                    <v-icon
                      style="cursor: pointer"
                      @click="pwdVisible = !pwdVisible"
                      >{{ pwdVisible ? "mdi-eye-off" : "mdi-eye" }}</v-icon
                    >
                  </template>
                </v-text-field>
                <v-text-field
                  v-model="$v.resetPassword.newPassword.$model"
                  label="Nuova password"
                  :type="pwdVisible ? 'text' : 'password'"
                  :error-messages="newErrors"
                  @input="$v.resetPassword.newPassword.$touch()"
                  @blur="$v.resetPassword.newPassword.$touch()"
                  minlength="8"
                  maxlength="100"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="$v.resetPassword.confirmPassword.$model"
                  label="Conferma nuova password"
                  :type="pwdVisible ? 'text' : 'password'"
                  :error-messages="confirmErrors"
                  @input="$v.resetPassword.confirmPassword.$touch()"
                  @blur="$v.resetPassword.confirmPassword.$touch()"
                  minlength="8"
                  maxlength="100"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </sea-page-content>
  </sea-page>
</template>

<script>
import axios from "axios";
import { SERVER_API_URL, INVALID_PASSWORD } from "@/constants";
import { mapActions, mapGetters } from "vuex";
import mixin from "@/mixin";
import { validationMixin } from "vuelidate";
import {
  maxLength,
  minLength,
  required,
  sameAs,
} from "vuelidate/lib/validators";
import { PASSWORD_POLICY } from "@/constants";

const validations = {
  resetPassword: {
    currentPassword: {
      required,
    },
    newPassword: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(100),
    },
    confirmPassword: {
      sameAsPassword: sameAs("newPassword"),
    },
  },
};

export default {
  mixins: [mixin, validationMixin],
  validations,
  data() {
    return {
      pwdPolicyRules: PASSWORD_POLICY,
      success: null,
      error: null,
      invalid: null,
      wrong: null,
      pwdVisible: false,
      resetPassword: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      activeProfile: "account/activeProfile",
    }),
    currentErrors() {
      const errors = [];
      if (!this.$v.resetPassword.currentPassword.$dirty) return errors;
      !this.$v.resetPassword.currentPassword.required &&
        errors.push(this.locales.required);
      return errors;
    },
    newErrors() {
      const errors = [];
      if (!this.$v.resetPassword.newPassword.$dirty) return errors;
      !this.$v.resetPassword.newPassword.required &&
        errors.push(this.locales.required);
      !this.$v.resetPassword.newPassword.minLength &&
        errors.push(this.locales.minLength(8));
      !this.$v.resetPassword.newPassword.maxLength &&
        errors.push(this.locales.maxLength(100));
      return errors;
    },
    confirmErrors() {
      const errors = [];
      if (!this.$v.resetPassword.confirmPassword.$dirty) return errors;
      !this.$v.resetPassword.confirmPassword.sameAsPassword &&
        errors.push(this.locales.sameAs);
      return errors;
    },
  },
  methods: {
    ...mapActions({ alert: "snackbar/openSnackbar" }),
    changePassword() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        axios
          .post(`${SERVER_API_URL}/api/account/change-password`, {
            currentPassword: this.resetPassword.currentPassword,
            newPassword: this.resetPassword.newPassword,
          })
          .then(() => {
            this.alert("La password e' stata modificata.");
          })
          .catch((error) => {
            if (
              error.response.status === 400 &&
              error.response.data.type === INVALID_PASSWORD
            ) {
              this.alert(error.response.data.title);
            } else if (error.response.status === 404) {
              this.alert("La password corrente è errata.");
            } else {
              this.alert(error.response.data.detail);
            }
          });
      }
    },
  },
};
</script>

<style scoped>
p {
  word-break: keep-all;
}
</style>
